class SiteNav {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let targets = document.querySelectorAll('[id*=anchor]');

    targets.forEach(function(el) {

      gsap.to(el, { // .box => アニメーションさせる要素
        scrollTrigger: {
          trigger: el, // トリガーとなる要素（アニメーションの開始、終了の位置決定に使用する）
          start: 'top center', // アニメーションの開始位置の指定
          end: 'bottom center', // アニメーションの開始位置の指定
          onEnter: (el) => {
            let elId = el.trigger.getAttribute('id');
            $(`[href*=${elId}`).siblings().removeClass('is-active');
            $(`[href*=${elId}`).addClass('is-active');
          },
          onLeaveBack: (el) => {
            let elId = el.trigger.getAttribute('id');
            $(`[href*=${elId}`).prev().siblings().removeClass('is-active');
            $(`[href*=${elId}`).prev().addClass('is-active');
          }
        }
      });
    })
  }
}
